<template>
  <div class="card terminology-custom" style="box-shadow: none">
    <b-modal :active.sync="modal.formUpdate" has-modal-card>
      <terminology-form-update
        :terminology="terminologySelected"
        @submit="onFormUpdateSubmit"
      />
    </b-modal>
    <header class="card-header">
      <div class="card-header-title has-text-dark is-size-4">Custom</div>
    </header>
    <div class="card-content scrollable">
      <base-table
        :service="$options.terminologyService"
        fetch-func="all"
        :fetch-params="{ type: 'custom', firm_id: user.firm.id }"
        :columns="$options.columns"
        ref="table"
      >
        <template #rowActions="{ row }">
          <b-button
            type="is-link"
            :disabled="!canManageTerminology"
            @click="onTableEdit(row)"
          >
            EDIT
          </b-button>
        </template>
      </base-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BaseTable from "@/components/partials/BaseTable";
import TerminologyFormUpdate from "@/components/Terminology/TerminologyFormUpdate";
import { TerminologyService } from "@/services/terminology.service";

export default {
  terminologyService: TerminologyService,
  columns: [
    {
      field: "key",
      label: "Key"
    },
    {
      field: "value",
      label: "Value"
    },
    {
      field: "actions",
      label: "",
      numeric: true,
      meta: {
        rowSlot: "rowActions"
      }
    }
  ],
  components: {
    BaseTable,
    TerminologyFormUpdate
  },

  data: () => ({
    modal: {
      formUpdate: false
    },
    terminologySelected: null
  }),
  computed: {
    ...mapState({
      user: state => state.Auth.user
    }),
    canManageTerminology() {
      return this.$store.getters["Auth/hasPermission"](
        "can manage terminology"
      );
    }
  },
  mounted() {
    this.fetch();
  },
  methods: {
    fetch() {
      return this.$refs.table.fetchData();
    },
    onTableEdit(terminology) {
      this.terminologySelected = terminology;
      this.modal.formUpdate = true;
    },
    onFormUpdateSubmit(terminology) {
      this.fetch();
      this.$emit("updated", terminology);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Terminology/TerminologyTableCustom.vue